export default "__VITE_ASSET__DqKcRNcb__"